// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"logo-2OIO7ile","breadcrumbs":"breadcrumbs-MEZ5W2XH"};